<script setup lang="ts">
import OfferTileGems from '@/components/shared/OfferTileGems.vue'

interface Props {
  catOffers?: Array<Games.Offer>
  bgImg?: string
  title: string
  tileSizeClass?: string
  blockCustomClass?: string
  showGameLogo?: boolean
  discountRibbonSize?: Partial<Record<'big' | 'medium' | 'mini' | 'miniGems', boolean>>
  ratio?: number
  gemsType?: boolean
  gapClass?: string
}
// const props =
defineProps<Props>()
</script>

<template>
  <div
    v-if="catOffers?.length"
    class="px-1 py-2 sm:px-4 bg-repeat-y sm:pb-8 big:py-[4vh] 2xl:py-[8vh]"
    :class="[blockCustomClass]"
    :style="`background-image: url('${bgImg}'); background-size: 100% auto;`"
  >
    <h3 class="text-center font-black uppercase text-xl xl:text-2xl 2xl:text-3xl mt-6 sm:mt-8 big:mt-10 mb-7">
      {{ title }}
    </h3>
    <div
      class="flex flex-wrap justify-center items-end mb-6 sm:max-w-xl big:max-w-5xl mx-auto"
      :class="[gapClass || 'gap-y-6']"
    >
      <div
        v-for="(item, index) in catOffers"
        :key="`${item?.id}_${index}_${item.gameKey}`"
        class="px-1 big:px-2"
        :class="[{ 'opacity-20': (item?.expireSec || 0) < 0 }, tileSizeClass]"
      >
        <OfferTileGems
          v-if="gemsType"
          :offer="item"
          :show-game-logo="showGameLogo"
          :discount-ribbon-size="discountRibbonSize"
          :ratio="ratio"
        />
        <OfferTileStandard
          v-else
          :offer="item"
          :show-game-logo="showGameLogo"
          :discount-ribbon-size="discountRibbonSize"
          :ratio="ratio"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">

</style>
